module.exports = __webpack_public_path__ + "static/media/logo-헤븐트리@2x.442961ab.png";